module.exports = __webpack_public_path__ + "img/lock.49ce3801.svg";